export { default } from './ServerStyleSheets';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/ServerStyleSheets/index.js
// module id = 626
// module chunks = 0